//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProgramUpdatedMessage } from './program-updated.message';

@PresenterType(
{
    model: ProgramUpdatedMessage
})
@Component({
    selector: 'program-updated-message-template',
    templateUrl: './program-updated-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgramUpdatedMessageTemplateComponent
{
    public data: WritableSignal<ProgramUpdatedMessage>;
    
    constructor() {
        this.data = signal<ProgramUpdatedMessage>(null);
    }
}